import ShadowContainerHorizontal from '@atoms/ShadowContainerHorizontal/ShadowContainerHorizontal';
import { IBreadcrumb } from '@models/IBreadcrumb';
import BreadcrumbLinks from '@molecules/BreadcrumbLinks/BreadcrumbLinks';
import classNames from 'classnames';
import { useRef } from 'react';

const Breadcrumb = ({ links, activePage, isInFooter }: IBreadcrumb) => {
  const scrollRef = useRef<HTMLHeadingElement>(null);

  return (
    <section
      className={classNames('relative w-full', {
        'bg-white dark:bg-black-100 lg:py-6': !isInFooter,
      })}
      data-testid="CT-31-Breadcrumbs"
    >
      <div className={classNames({ 'md:container': !isInFooter })}>
        <ShadowContainerHorizontal
          shadowColour="from-grey-100 dark:from-grey-600"
          shadowWidth="w-13"
          className="py-4"
          threshold={0.01}
        >
          <BreadcrumbLinks
            links={links}
            activePage={activePage}
            scrollRef={scrollRef}
            isInFooter={isInFooter}
          />
        </ShadowContainerHorizontal>
      </div>
    </section>
  );
};

export default Breadcrumb;
